import CompOffReportTypes from './CompOffReport.types';

export const getAllCompOffByOrgStart = (data: any) => ({
	type: CompOffReportTypes.GET_ALL_COMPOFF_BY_ORG_START,
	payload: data,
});

export const getAllCompOffByOrgSuccess = (data: any) => ({
	type: CompOffReportTypes.GET_ALL_COMPOFF_BY_ORG_SUCCESS,
	payload: data,
});

export const getAllCompOffByOrgFailure = (error: unknown) => ({
	type: CompOffReportTypes.GET_ALL_COMPOFF_BY_ORG_FAILURE,
	payload: error,
});

export const getAllCompOffByOrgReset = () => ({
	type: CompOffReportTypes.GET_ALL_COMPOFF_BY_ORG_RESET,
});
